"use client";

import { NavigationMenu as Primitive } from "@base-ui/react/navigation-menu";
import { type ReactNode, useCallback, useState } from "react";

/** The header menu whose panels open as one full-width sheet right under the whole header bar, not under their own title (our own copy of the shadcn menu root, whose positioner is fixed to the title). Same parts (list, item, trigger, content) as `@/components/ui/navigation-menu`. */
export function WideNavigationMenu({ children, className, ...props }: Primitive.Root.Props & { children?: ReactNode }) {
  const [header, setHeader] = useState<HTMLElement | null>(null);
  const root = useCallback((el: HTMLElement | null) => setHeader(el?.closest("header") ?? null), []);
  return (
    <Primitive.Root ref={root} data-slot="navigation-menu" className={`group/navigation-menu relative flex max-w-max flex-1 items-center justify-center ${className ?? ""}`} {...props}>
      {children}
      <Primitive.Portal>
        <Primitive.Positioner anchor={header ?? undefined} side="bottom" align="start" sideOffset={0} className="isolate z-50 h-(--positioner-height) w-(--anchor-width) max-w-none transition-[top,left,right,bottom] duration-300 data-instant:transition-none">
          <Primitive.Popup className="relative h-(--popup-height) w-full origin-(--transform-origin) border-y bg-popover text-popover-foreground shadow-lg outline-none transition-[opacity,height] duration-300 data-ending-style:opacity-0 data-starting-style:opacity-0">
            <Primitive.Viewport className="relative size-full" />
          </Primitive.Popup>
        </Primitive.Positioner>
      </Primitive.Portal>
    </Primitive.Root>
  );
}
